import axios from "axios";

export const Data = {}

Data.install = function (Vue, options) {
  Vue.prototype.$checkValue = (value) => {
    return checkValue(value)
  }
  Vue.prototype.$parseJwt = (value) => {
    return parseJwt(value)
  }
  Vue.prototype.$reverseGeocode = (value) => {
    return reverseGeocode(value)
  }
}

export function checkValue(value) {
  if (value === undefined) {
    return 0
  } else {
    return value
  }
}

export function parseJwt(token) {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export function reverseGeocode(coordinate) {
  if (coordinate === undefined) {
    return null
  }

  return axios.get(`https://maps.google.com/maps/api/geocode/json?latlng=${coordinate.latitude/100000},${coordinate.longitude/100000}&key=AIzaSyAq6EpN0DkLaGirArQKtKwxL0ajuddHowQ`)
    .catch(error => {
      console.log(error)
    })
}
